import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wheelContainer: {
    display: 'flex',
    position: 'relative',
    width: 'fit-content',
    margin: '0 auto',

    '&::after': {
      position: 'absolute',
      content: '""',
      top: 'calc(50% + 8px)',
      transform: 'translateY(-50%)',
      left: '0',
      right: '0',
      width: '100%',
      height: 'var(--wheel-item-height, 32px)',
      borderColor: theme.palette.primary.main,
      borderWidth: '2px',
      borderStyle: 'solid',
      borderRadius: '5px',
      pointerEvents: 'none',
      zIndex: 1,
      boxSizing: 'border-box',
    },
  },
  wheelItems: {
    margin: '0',
    overflowY: 'scroll',
    overflowX: 'hidden',
    scrollSnapType: 'y mandatory',
    MsOverflowStyle: 'none',
    scrollbarWidth: 'none',
    WebkitMaskImage:
      'linear-gradient(to bottom, transparent 0%, black 50%, transparent 100%)',
    maskImage:
      'linear-gradient(to bottom, transparent 0%, black 50%, transparent 100%)',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },

  wheelItem: {
    marginRight: '10px',
    listStyleType: 'none',
    width: '100%',
    textAlign: 'right',
    scrollSnapAlign: 'center',
    cursor: 'pointer',

    '& div': {
      display: 'inline-block',
      fontSize: '14px',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  wheelColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 'none',
  },
  wheelLabel: {
    color: `${theme.palette.font.primary} !important`,
    marginBottom: theme.spacing(0.5),
    flexShrink: 0,
  },
}));
